"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SideModalInner", {
    enumerable: true,
    get: function() {
        return SideModalInner;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _ModalContext = require("../ModalContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const SideModalInner = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, className, containerClassName, hideOnEsc = true, hideOnClick = true, expansion, expansionBackground = "#fff" } = param;
    const { colors, breakpoints } = (0, _Theme.useTheme)();
    const { title, onHide, size } = (0, _react.useContext)(_ModalContext.ModalContext);
    const { zIndexes } = (0, _Theme.useTheme)();
    const onKeyDown = (0, _react.useCallback)((e)=>{
        if (e.key === "Escape") {
            e.stopPropagation();
            if (hideOnEsc) {
                onHide();
            }
        }
    }, [
        hideOnEsc,
        onHide
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        onClick: hideOnClick ? onHide : undefined,
        onKeyDown: onKeyDown,
        ref: ref,
        className: _style.default.dynamic([
            [
                "246c5afdc73348e7",
                [
                    zIndexes.modal,
                    expansionBackground,
                    expansion != null ? "transparent" : colors.border,
                    {
                        xs: "300px",
                        sm: "360px",
                        md: "560px",
                        lg: "800px",
                        xl: "1000px",
                        auto: "auto"
                    }[size],
                    breakpoints.md,
                    breakpoints.lg
                ]
            ]
        ]) + " " + (containerClassName || "")
    }, expansion != null && /*#__PURE__*/ _react.default.createElement("section", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: _style.default.dynamic([
            [
                "246c5afdc73348e7",
                [
                    zIndexes.modal,
                    expansionBackground,
                    expansion != null ? "transparent" : colors.border,
                    {
                        xs: "300px",
                        sm: "360px",
                        md: "560px",
                        lg: "800px",
                        xl: "1000px",
                        auto: "auto"
                    }[size],
                    breakpoints.md,
                    breakpoints.lg
                ]
            ]
        ]) + " " + "left"
    }, expansion), /*#__PURE__*/ _react.default.createElement("section", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: _style.default.dynamic([
            [
                "246c5afdc73348e7",
                [
                    zIndexes.modal,
                    expansionBackground,
                    expansion != null ? "transparent" : colors.border,
                    {
                        xs: "300px",
                        sm: "360px",
                        md: "560px",
                        lg: "800px",
                        xl: "1000px",
                        auto: "auto"
                    }[size],
                    breakpoints.md,
                    breakpoints.lg
                ]
            ]
        ]) + " " + "right ".concat(className)
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "246c5afdc73348e7",
        dynamic: [
            zIndexes.modal,
            expansionBackground,
            expansion != null ? "transparent" : colors.border,
            {
                xs: "300px",
                sm: "360px",
                md: "560px",
                lg: "800px",
                xl: "1000px",
                auto: "auto"
            }[size],
            breakpoints.md,
            breakpoints.lg
        ]
    }, ".uf-visible{display:none!important}div.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:right;-webkit-justify-content:right;-moz-box-pack:right;-ms-flex-pack:right;justify-content:right;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;width:100%;height:100%;overflow:none;z-index:".concat(zIndexes.modal, ";-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}div.__jsx-style-dynamic-selector *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.left.__jsx-style-dynamic-selector{background:").concat(expansionBackground, ";-webkit-box-flex:2;-webkit-flex:2;-moz-box-flex:2;-ms-flex:2;flex:2;height:100%;overflow:auto}.right.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;pointer-events:all;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;background:#fff;border:1px solid ").concat(expansion != null ? "transparent" : colors.border, ";height:100%;max-height:100%;width:min(\n              100%,\n              ").concat({
        xs: "300px",
        sm: "360px",
        md: "560px",
        lg: "800px",
        xl: "1000px",
        auto: "auto"
    }[size], "\n            );max-width:100vw}@media(max-width:").concat(breakpoints.md, "px){.right.__jsx-style-dynamic-selector{min-width:100%;width:100%}}@media(max-width:").concat(breakpoints.lg, "px){.left.__jsx-style-dynamic-selector{position:absolute;left:0;top:0;z-index:2;width:100%}}")));
});
SideModalInner.displayName = "SideModalInner";

//# sourceMappingURL=SideModalInner.js.map